export default __webpack_public_path__ + "static/media/nodejs_logo.9aa6fa44.png";